import ColoringApp from './ColoringApp.jsx';
import TicTacToeApp from './TicTacToeApp.jsx';
import MathQuizApp from './MathQuizApp.jsx';
import MultipleChoiceEngine from './engines/MultipleChoiceEngine.jsx';
import SequenceEngine from './engines/SequenceEngine.jsx';
import MatchEngine from './engines/MatchEngine.jsx';
import ExplorationCardEngine from './engines/ExplorationCardEngine.jsx';
import PatternEngine from './engines/PatternEngine.jsx';
import CanvasManipulativeEngine from './engines/CanvasManipulativeEngine.jsx';
import TapOnImageEngine from './engines/TapOnImageEngine.jsx';
import SimulationScrubEngine from './engines/SimulationScrubEngine.jsx';
import GearRatioEngine from './engines/GearRatioEngine.jsx';
import CircuitBuilderEngine from './engines/CircuitBuilderEngine.jsx';
import GearDirectionEngine from './engines/GearDirectionEngine.jsx';
import GearSpeedEngine from './engines/GearSpeedEngine.jsx';
import CircuitPathEngine from './engines/CircuitPathEngine.jsx';
import SwitchLogicEngine from './engines/SwitchLogicEngine.jsx';
import SystemFlowEngine from './engines/SystemFlowEngine.jsx';
import VariableSimulationEngine from './engines/VariableSimulationEngine.jsx';
import EvidenceDetectiveEngine from './engines/EvidenceDetectiveEngine.jsx';
import { storyEngineRegistry } from '../engines/engineRegistry';

/**
 * Mini-app registry for chat/embed: JSON { type: 'miniapp', app: '<key>', props: {...} }
 * Engine apps expect props: { title?, content, hints?, onProgress?, onComplete?, activityId? }
 */
export const miniAppRegistry = {
  coloring: ColoringApp,
  tictactoe: TicTacToeApp,
  mathquiz: MathQuizApp,
  engine_multiple_choice: MultipleChoiceEngine,
  engine_sequence: SequenceEngine,
  engine_match: MatchEngine,
  engine_exploration_cards: ExplorationCardEngine,
  engine_pattern: PatternEngine,
  engine_canvas_manipulative: CanvasManipulativeEngine,
  engine_tap_on_image: TapOnImageEngine,
  engine_simulation_scrub: SimulationScrubEngine,
  engine_gear_ratio: GearRatioEngine,
  engine_circuit_builder: CircuitBuilderEngine,
  engine_gear_direction: GearDirectionEngine,
  engine_gear_speed: GearSpeedEngine,
  engine_circuit_path: CircuitPathEngine,
  engine_switch_logic: SwitchLogicEngine,
  engine_system_flow: SystemFlowEngine,
  engine_variable_simulation: VariableSimulationEngine,
  engine_evidence_detective: EvidenceDetectiveEngine,
  ...storyEngineRegistry,
};
